<template>
  <section class="n-section-primary tw-relative" :style="`background-color: var(--c-${vars.backgroundColor})`">
    <div
      v-if="company.company_key === 'townandcityhomes'"
      class="tw-pointer-events-none tw-absolute tw-bottom-0 tw-left-0 tw-hidden lg:tw-block"
    >
      <span
        ><svg width="419" height="445" viewBox="0 0 419 445" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_9_2220)">
            <path
              d="M403.2 237.4C378.6 199.8 332.1 189.3 298.1 195.6C255.7 203.5 224.3 239.5 211.1 279.9C204.7 300.1 202.9 321.4 206.5 340.8C211.1 365.1 223.6 383 233.2 394.1C234.5 395.3 234.8 396.9 234.2 397.7C233.7 398.4 232.7 398.4 232 398.3C230.3 398 229.3 396.8 228.1 395.8C226.9 394.8 225.9 393.6 224.7 392.4C222.5 390.2 220.4 387.9 218.3 385.4C214.1 380.6 210.4 375.5 206.9 370.3C203.5 365.1 200.5 359.5 197.9 353.8C195.2 348.1 193 342.3 191.2 336.3C189.4 330.3 187.9 324.2 187 318C186 311.9 185.4 305.6 185.2 299.3C185.1 293 185.4 286.7 185.9 280.4V279.9C186.7 273.8 187.8 267.6 189.3 261.6C190.1 258.6 191 255.8 191.8 252.9C194.3 245.3 198.5 238.2 201.1 230.7L137.5 167.7C71.3 195.4 66.2 197.5 0 225V429.1C0 431 0.4 432.8 1.2 434.6C3.3 440.1 8.7 444 15 444H333.8C333.6 444 333.5 443.8 333.3 443.7C326.4 439.7 309.8 428.3 301.1 407C290.2 380 295.7 345.9 318.8 324.3C323.1 320.1 328.1 316.7 333.3 314C357.9 300.5 389.8 301.7 414.9 319.1C416.8 311.9 426.4 272.7 403.2 237.2"
              fill="#2D1559"
            />
            <path
              d="M190.9 180.5C190.9 182.2 190.9 183.8 190.7 185.5H227.7C227.5 183.8 227.5 182.2 227.5 180.5C227.5 140.7 255.5 108.6 290.1 108.6C324.7 108.6 295.6 108.8 298.3 109.3V0C270.2 0 247.2 22.9 247.2 51.2H171C171 22.9 148.1 0 119.9 0V109.3C122.6 108.8 125.3 108.6 128.1 108.6C162.7 108.6 190.7 140.7 190.7 180.5"
              fill="#2D1559"
            />
          </g>
          <defs>
            <clipPath id="clip0_9_2220">
              <rect width="418.5" height="444.2" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </span>
    </div>

    <div>
      <h2 :style="`color: var(--c-${vars.textColor})`" class="tw-mb-6 lg:tw-mb-12">{{ vars.titleText }}</h2>
    </div>
    <div class="tw-w-full">
      <Swiper
        @swiper="onSwiper"
        @slideChange="onSlideChange"
        :pagination="false"
        :slides-per-view="3"
        :space-between="24"
        :clickable="true"
        :breakpoints="{
          320: { slidesPerView: 1, spaceBetween: 20 },
          768: { slidesPerView: 2, spaceBetween: 24 },
          1024: { slidesPerView: 4, spaceBetween: 24 },
        }"
        class="tw-w-full"
      >
        <SwiperSlide v-for="(video, index) in videos" :key="`video-testimonial-${index}`" class="!tw-flex !tw-h-auto">
          <MotionGroup is="div" preset="slideVisibleBottom" class="tw-w-full">
            <div
              class="n-card tw-group tw-relative tw-flex tw-min-h-[500px] tw-w-full tw-cursor-pointer tw-flex-col tw-overflow-hidden tw-rounded-[var(--c-rounded)] tw-text-start tw-transition-all tw-duration-500 xl:tw-h-auto xl:tw-min-h-[300px]"
              style="border-radius: var(--rounded)"
              :style="`background-color: var(--c-${vars.cardBackgroundColor})`"
            >
              <!-- Resim Alanı -->
              <div class="tw-relative">
                <div class="tw-relative tw-p-4">
                  <library-iframe
                    v-if="video.video"
                    :src="video.video"
                    :h-ratio="16"
                    :w-ratio="10"
                    style="border-radius: var(--rounded)"
                  />
                </div>
              </div>
              <!-- Kart Bilgi Alanı: Başlık ve Buton -->
              <div
                class="tw-flex tw-h-full tw-flex-col tw-items-start tw-justify-end tw-gap-4 tw-px-4 tw-py-6 tw-text-left"
              >
                <h4 class="tw-mb-2 tw-line-clamp-2 tw-h-16 tw-overflow-hidden tw-text-[--c-text_secondary]">
                  {{ video.title }}
                </h4>
                <h6 style="color: var(--c-secondary)">VIEW THIS REVIEW</h6>
              </div>
            </div>
          </MotionGroup>
        </SwiperSlide>
      </Swiper>
      <!-- Slider Pagination (mobil versiyon için) -->
      <div class="controls">
        <div
          data-w-id="080a9ca2-7a2d-2ca3-3b22-f42b27569daf"
          class="slide-left-arrow w-slider-arrow-left"
          :isDisabled="!canPaginateBack"
          @click="() => swiper.slidePrev()"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M16.011 3.49956C16.1418 3.6335 16.2151 3.81332 16.2151 4.00056C16.2151 4.18781 16.1418 4.36762 16.011 4.50156L8.70149 12.0001L16.011 19.4971C16.1418 19.631 16.2151 19.8108 16.2151 19.9981C16.2151 20.1853 16.1418 20.3651 16.011 20.4991C15.9474 20.5644 15.8714 20.6163 15.7874 20.6517C15.7034 20.6872 15.6132 20.7054 15.522 20.7054C15.4308 20.7054 15.3406 20.6872 15.2566 20.6517C15.1726 20.6163 15.0966 20.5644 15.033 20.4991L7.25999 12.5236C7.12347 12.3835 7.04706 12.1957 7.04706 12.0001C7.04706 11.8045 7.12347 11.6166 7.25999 11.4766L15.033 3.50106C15.0966 3.43575 15.1726 3.38383 15.2566 3.34839C15.3406 3.31294 15.4308 3.29468 15.522 3.29468C15.6132 3.29468 15.7034 3.31294 15.7874 3.34839C15.8714 3.38383 15.9474 3.43575 16.011 3.50106V3.49956Z"
              fill="#6EADAB"
            />
          </svg>
          <div class="slide-circle slider-circle-transform"></div>
        </div>
        <div
          data-w-id="080a9ca2-7a2d-2ca3-3b22-f42b27569db1"
          class="slide-right-arrow w-slider-arrow-right"
          :isDisabled="!canPaginateNext"
          @click="() => swiper.slideNext()"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.98901 3.49956C7.85817 3.6335 7.78491 3.81332 7.78491 4.00056C7.78491 4.18781 7.85817 4.36762 7.98901 4.50156L15.2985 12.0001L7.98901 19.4971C7.85817 19.631 7.78491 19.8108 7.78491 19.9981C7.78491 20.1853 7.85817 20.3651 7.98901 20.4991C8.0526 20.5644 8.12864 20.6163 8.21263 20.6517C8.29661 20.6872 8.38685 20.7054 8.47801 20.7054C8.56917 20.7054 8.65941 20.6872 8.74339 20.6517C8.82738 20.6163 8.90342 20.5644 8.96701 20.4991L16.74 12.5236C16.8765 12.3835 16.9529 12.1957 16.9529 12.0001C16.9529 11.8045 16.8765 11.6166 16.74 11.4766L8.96701 3.50106C8.90342 3.43575 8.82738 3.38383 8.74339 3.34839C8.65941 3.31294 8.56917 3.29468 8.47801 3.29468C8.38685 3.29468 8.29661 3.31294 8.21263 3.34839C8.12864 3.38383 8.0526 3.43575 7.98901 3.50106V3.49956Z"
              fill="#6EADAB"
            />
          </svg>
          <div class="slide-circle right"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { mapState } from 'pinia';
import { ComponentMixin } from '~/mixins/component.mixin';
import GuideCard from './GuideCard.vue';
import { useWebsiteStore } from '~/units/website/store';
import Popup from '~/components/common/popup/Popup.vue';

export default defineNuxtComponent({
  name: 'VideoTestimonials',

  mixins: [ComponentMixin],

  components: { GuideCard, Popup },

  data() {
    return {
      swiper: null,
      canPaginateBack: true,
      canPaginateNext: true,
      selectedGuide: null,
      form: null,
      variants: {
        v1: 'v1',
        v2: 'v2',
      },
      popupConfig: {
        isActive: false,
      },
    };
  },

  computed: {
    ...mapState(useWebsiteStore, ['sidebarComponents']),
    videos() {
      return this.groupedVariables.videos;
    },

    ...mapState(useWebsiteStore, ['sidebarComponents']),
  },

  methods: {
    onSwiper(swiper) {
      this.swiper = swiper;
    },

    onSlideChange() {
      if (!this.swiper) return;
      const isAtStart = this.swiper.isBeginning;
      const isAtEnd = this.swiper.isEnd;
      if (isAtStart) this.canPaginateBack = false;
      else this.canPaginateBack = true;
      if (isAtEnd) this.canPaginateNext = false;
      else this.canPaginateNext = true;
    },
    handleGuideClick(guide) {
      if (guide.guide) {
        this.form = this.parseFormV2(guide.guide);
        this.toggleGuidePopup(guide, true);
      } else if (guide.button_link) {
        this.$router.push(guide.button_link);
      }
    },
    toggleGuidePopup(guide = null, value = false) {
      this.selectedGuide = guide;
      this.popupConfig.isActive = value;
    },
  },

  mounted() {
    this.onSlideChange();
  },
});
</script>
